module.exports = __webpack_public_path__ + "static/media/derya1.c6169f43.jpg";